import React, { useState } from 'react';
import { Row, Col, Avatar, Spin } from 'antd';
import { TextField } from '../../../components';
import { IoIosArrowForward, IoIosSearch } from 'react-icons/io';
import { HiOutlineBellAlert } from 'react-icons/hi2';
import DropDown from '../../../components/DropDown';
import { UserOutlined } from '@ant-design/icons';
import { ApiCaller, Colors, Utils } from '../../../config';
import { Link, useNavigate } from 'react-router-dom';
import { useForm, Controller } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { UserPasswordChange } from '../../../config/Schema';
import LabelWithField from '../../../components/LabelWithField';
import LabelWithFieldIcon from '../../../components/LabelWithFieldIcon';
import { IoIosEyeOff } from 'react-icons/io';
import { IoIosEye } from 'react-icons/io';
import useColors from '../../../hooks/useColors';
import DashboardActionBar from '../../../components/DashboardActionBar';

const ChangePassword = () => {
    const { colorPrimary } = useColors();
    const user = JSON.parse(localStorage.getItem('user'));

    const schema = UserPasswordChange;
    const { control, handleSubmit } = useForm({
        resolver: yupResolver(schema),
    });

    const [loading, setLoading] = useState(false); // Create loading state

    const formHandler = (data) => {
        setLoading(true); // Show loader
        console.log(data);
        ApiCaller.Patch('/password/update', data)
            .then((response) => {
                Utils.showMessage(
                    'success',
                    response?.data?.message || 'Password updated successfully',
                );
            })
            .catch((err) => {
                Utils.showMessage(
                    'error',
                    err?.response?.data?.message ||
                    'An error occurred while updating the password',
                );
            })
            .finally(() => {
                console.log(data);
                setLoading(false); // Hide loader after API call is finished
            });
    };

    const navigate = useNavigate();

    const [state, setState] = useState({
        current_password: false,
        new_password: false,
        confirmPassword: false,
    });

    const options = [
        {
            label: 'My Availability',
            value: '1',
        },
        {
            label: 'Edit Profile',
            value: '2',
        },
        {
            label: 'Change Password',
            value: '3',
        },
    ];

    const dropDownSelector = (e) => {
        if (e.key === 'tmp-0') {
            navigate('/MyAvailability');
            return;
        } else if (e.key === 'tmp-1') {
            navigate('/EditProfile');
            return;
        } else if (e.key === 'tmp-2') {
            navigate('/ChangePassword');
            return;
        }
    };
    return (
        <>
            <DashboardActionBar
                text='Change Password'
            />

            <Row
                style={{ background: Colors.White }}
                justify={'center'}
                align={'middle'}
                className="w-full rounded-lg py-6 px-2"
            >
                <form
                    className="md:w-1/2 mx-auto px-2 w-full"
                    onSubmit={handleSubmit(formHandler)}
                    style={{}}
                >
                    <Controller
                        name="current_password"
                        control={control}
                        render={({
                            field: { value, onChange },
                            fieldState,
                        }) => {
                            return (
                                <>
                                    <LabelWithFieldIcon
                                        type={
                                            state.current_password
                                                ? 'text'
                                                : 'password'
                                        }
                                        value={value}
                                        onChange={onChange}
                                        inputClass="py-2 px-2 rounded-md w-full md:w-10/12"
                                        labeltext={'Current Password'}
                                        suffix={
                                            state.current_password ? (
                                                <IoIosEye
                                                    size={18}
                                                    className="cursor-pointer"
                                                    color={Colors.LabelColor}
                                                    onClick={() =>
                                                        setState({
                                                            ...state,
                                                            current_password: false,
                                                        })
                                                    }
                                                />
                                            ) : (
                                                <IoIosEyeOff
                                                    size={18}
                                                    className="cursor-pointer"
                                                    color={Colors.LabelColor}
                                                    onClick={() =>
                                                        setState({
                                                            ...state,
                                                            current_password: true,
                                                        })
                                                    }
                                                />
                                            )
                                        }
                                    />
                                    {fieldState.error ? (
                                        <p
                                            className=""
                                            style={{ color: Colors.Error }}
                                        >
                                            {fieldState.error.message}
                                        </p>
                                    ) : (
                                        ''
                                    )}
                                </>
                            );
                        }}
                    />

                    <Controller
                        name="new_password"
                        control={control}
                        render={({
                            field: { value, onChange },
                            fieldState,
                        }) => {
                            return (
                                <>
                                    <LabelWithFieldIcon
                                        type={
                                            state.new_password
                                                ? 'text'
                                                : 'password'
                                        }
                                        value={value}
                                        onChange={onChange}
                                        inputClass="py-2 px-2 rounded-md w-full md:w-10/12"
                                        labeltext={'New Password'}
                                        suffix={
                                            state.new_password ? (
                                                <IoIosEye
                                                    size={18}
                                                    color={Colors.LabelColor}
                                                    className="cursor-pointer"
                                                    onClick={() =>
                                                        setState({
                                                            ...state,
                                                            new_password: false,
                                                        })
                                                    }
                                                />
                                            ) : (
                                                <IoIosEyeOff
                                                    size={18}
                                                    color={Colors.LabelColor}
                                                    className="cursor-pointer"
                                                    onClick={() =>
                                                        setState({
                                                            ...state,
                                                            new_password: true,
                                                        })
                                                    }
                                                />
                                            )
                                        }
                                    />
                                    {fieldState.error ? (
                                        <p
                                            className=""
                                            style={{ color: Colors.Error }}
                                        >
                                            {fieldState.error.message}
                                        </p>
                                    ) : (
                                        ''
                                    )}
                                </>
                            );
                        }}
                    />

                    <Controller
                        name="confirmPassword"
                        control={control}
                        render={({
                            field: { value, onChange },
                            fieldState,
                        }) => {
                            return (
                                <>
                                    <LabelWithFieldIcon
                                        type={
                                            state.confirmPassword
                                                ? 'text'
                                                : 'password'
                                        }
                                        value={value}
                                        onChange={onChange}
                                        inputClass="py-2 px-2 rounded-md w-full md:w-10/12"
                                        labeltext={'Confirm Password'}
                                        suffix={
                                            state.confirmPassword ? (
                                                <IoIosEye
                                                    size={18}
                                                    color={Colors.LabelColor}
                                                    className="cursor-pointer"
                                                    onClick={() =>
                                                        setState({
                                                            ...state,
                                                            confirmPassword: false,
                                                        })
                                                    }
                                                />
                                            ) : (
                                                <IoIosEyeOff
                                                    size={18}
                                                    className="cursor-pointer"
                                                    color={Colors.LabelColor}
                                                    onClick={() =>
                                                        setState({
                                                            ...state,
                                                            confirmPassword: true,
                                                        })
                                                    }
                                                />
                                            )
                                        }
                                    />
                                    {fieldState.error ? (
                                        <p
                                            className=""
                                            style={{ color: Colors.Error }}
                                        >
                                            {fieldState.error.message}
                                        </p>
                                    ) : (
                                        ''
                                    )}
                                </>
                            );
                        }}
                    />

                    <Row className="flex items-center justify-center w-10/12 my-6">
                        <input
                            type="submit"
                            value={loading ? 'Saving...' : 'Save'} // Change button text to "Saving..." while loading
                            className="px-11 py-3 rounded-md cursor-pointer"
                            style={{
                                background: colorPrimary,
                                color: Colors.White,
                                cursor: loading ? 'not-allowed' : 'pointer', // Disable button when loading
                            }}
                            disabled={loading}
                        />
                        {loading && (
                            <div className="absolute flex items-center justify-center">
                                <div className="loader"></div> <Spin />
                            </div>
                        )}
                    </Row>
                </form>
            </Row>
        </>
    );
};

export default ChangePassword;
